"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var DocMovetoSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M13.3365555,12 L12.1526536,10.8403341 C11.9588874,10.6515805 11.9548239,10.341487 12.1435775,10.1477208 L12.1466827,10.1445618 C12.339598,9.95007384 12.6530449,9.94688019 12.8498829,10.137397 L15.2829485,12.5 L12.8554738,14.8539867 C12.6582953,15.0451959 12.3441422,15.0427216 12.15,14.8484303 C11.9589656,14.6572493 11.9590845,14.3474024 12.1502656,14.1563681 L13.3350833,13 L10,13 L10,12 L13.3365555,12 Z M9,14 L9,15 L6,15 C5.44771525,15 5,14.5522847 5,14 L5,5 C5,4.44771525 5.44771525,4 6,4 L10.7,4 L13,6.3 L13.008756,8 L12,8 L12,6.7 L10.3034374,5 L6,5 L6,14 L9,14 Z" })));
};
DocMovetoSmall.displayName = 'DocMovetoSmall';
exports.default = DocMovetoSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=DocMovetoSmall.js.map